import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "width", "height"]

import { computed } from 'vue';

// A vector circle has no antialiasing in the browser, so using a png instead

export default /*@__PURE__*/_defineComponent({
  __name: 'd4yImg',
  props: {
  src: {
    type: String,
    default: '',
  },
  width: {
    type: [String, Number],
    default: undefined,
  },
  height: {
    type: [String, Number],
    default: undefined,
  },
  size: {
    type: [String, Number],
    default: undefined,
  },
  round: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

// v-img does not display svg - images anymore. This new component solves it by using an internal browser <img> - tag
const roundMask = require('@/assets/mask-circle.png');

const props = __props;

const widthInternal = computed(() => {
  return props.width ?? props.size ?? -1;
});

const heightInternal = computed(() => {
  return props.height ?? props.size ?? -1;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: __props.src,
    width: widthInternal.value,
    height: heightInternal.value,
    style: _normalizeStyle(
      __props.round
        ? `mask-image: url(${_unref(roundMask)}); mask-size: ${widthInternal.value}px ${heightInternal.value}px;`
        : ``
    )
  }, null, 12, _hoisted_1))
}
}

})